<script>
  export let text;
  export let link;
</script>

<a href={link}><button>{text}</button></a>

<style>
  button {
    font-family: 'Oswald';
    font-weight: normal;
    background-color: #f7931e;
    color: white;
    text-decoration: none;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    text-transform: uppercase;
    transition: 0.3s ease;
    font-size: 16px; /* Default font size */
  }

  button:hover {
    scale: 1.17;
  }

  /* Media query for devices with a max width of 768px */
  @media (max-width: 768px) {
    button {
      padding: 7px 13px; /* Cut the padding in half */
      font-size: 12px; /* Cut the font size in half */
    }
  }
</style>
